export const SIZE = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
}

export const VARIANT = {
  filled: 'filled',
  outlined: 'outlined',
  ghost: 'ghost',
  light: 'light',
  dark: 'dark'
}

export const TYPE = {
  button: 'button',
  reset: 'reset',
  submit: 'submit',
}
